module.exports = __webpack_public_path__ + "img/va.d76a4c0a.svg";